import { memo, useState } from "react";
import FormItemWrapper from "~/components/common/FormItemWrapper/FormItemWrapper";
import { Button, Input } from "antd";
import { OrganizationAPIs, Organization_Create_Request } from "~/common/typescript/apis/OrganizationAPIs";

export interface FormCreateOrganizationProps {
  callbackSuccess?: () => void;
}
const FormCreateOrganization = (props: FormCreateOrganizationProps) => {
  const [isLoading, setLoading] = useState(false);
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [taxId, setTaxId] = useState('');

  const onClickCreateOrg = async () => {
    try {
      setLoading(true);
      const request: Organization_Create_Request = {
        name,
        description,
        taxId: taxId || undefined,
      }
      await OrganizationAPIs.remote_create(request);
    } finally {
      if (props.callbackSuccess) {
        props.callbackSuccess();
        setLoading(false);
      }
    }
  }

  return (<>
    <FormItemWrapper label="Tên doanh nghiệp">
      <Input placeholder="Tên doanh nghiệp" value={name} onChange={(e) => setName(e.target.value)} />
    </FormItemWrapper>
    <FormItemWrapper label="Mô tả">
      <Input.TextArea placeholder="Mô tả" value={description} onChange={(e) => setDescription(e.target.value)} />
    </FormItemWrapper>
    <FormItemWrapper label="Mã số thuế">
      <Input placeholder="Mã số thuế (tùy chọn)" value={taxId} onChange={(e) => setTaxId(e.target.value)} />
    </FormItemWrapper>
    <div style={{ marginTop: 8, display: 'flex', justifyContent: 'flex-end' }}>
      <Button type="primary" onClick={onClickCreateOrg} loading={isLoading}>Tạo doanh nghiệp</Button>
    </div>
  </>)
};
export default memo(FormCreateOrganization);